import { render, staticRenderFns } from "./InventoryService.vue?vue&type=template&id=52c95310&scoped=true"
import script from "./InventoryService.vue?vue&type=script&lang=js"
export * from "./InventoryService.vue?vue&type=script&lang=js"
import style0 from "./InventoryService.vue?vue&type=style&index=0&id=52c95310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c95310",
  null
  
)

export default component.exports